/**
 * Custom hook for managing app user status (enable/disable)
 */
import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { UPDATE_USER_STATUS } from 'graphql/users/mutations'
import { t } from 'i18next'
import { APP_USER_POOL } from '../constants'
import { getStatusConfirmMessage } from '../helpers'

export default function useUserStatus(onSuccess) {
    // Dialog states
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [confirmMessage, setConfirmMessage] = useState('')

    // Status update states
    const [statusUserId, setStatusUserId] = useState('')
    const [userStatus, setUserStatus] = useState(false)

    // Mutation
    const [updateUserStatus, { loading: statusUpdateLoading }] = useMutation(UPDATE_USER_STATUS, {
        onCompleted: data => {
            if (data?.updateUserStatus?.code === '200') {
                setSuccessMessage(data?.updateUserStatus?.message || t('User status updated successfully'))
                setShowSucDialog(true)
                setTimeout(() => {
                    setShowSucDialog(false)
                    if (onSuccess) onSuccess()
                }, 500)
            } else {
                setErrorMessage(data?.updateUserStatus?.message || t('Problem updating the user status. Please try again.'))
                setShowErrDialog(true)
            }
        },
        onError: () => {
            setErrorMessage(t('Problem updating the user status. Please try again.'))
            setShowErrDialog(true)
        },
    })

    // Handlers
    const handleDisableUser = (userId, newStatus) => {
        setStatusUserId(userId)
        setUserStatus(newStatus)
        setConfirmMessage(getStatusConfirmMessage(newStatus))
        setShowConfirmDialog(true)
    }

    const handleConfirmPositive = () => {
        updateUserStatus({
            variables: {
                userPool: APP_USER_POOL,
                userId: statusUserId,
                enabled: userStatus,
                remarks: userStatus ? 'true user' : 'false user',
            },
        })
        setShowConfirmDialog(false)
    }

    const handleConfirmNegative = () => {
        setShowConfirmDialog(false)
    }

    const handleErrClose = () => {
        setShowErrDialog(false)
        setErrorMessage('')
    }

    const handleSucClose = () => {
        setShowSucDialog(false)
        setSuccessMessage('')
    }

    return {
        // States
        showErrDialog,
        showSucDialog,
        showConfirmDialog,
        errorMessage,
        successMessage,
        confirmMessage,
        statusUpdateLoading,
        // Handlers
        handleDisableUser,
        handleConfirmPositive,
        handleConfirmNegative,
        handleErrClose,
        handleSucClose,
    }
}
